import React from "react";
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Tooltip, Typography } from "@mui/material";


export const NavListItem = (props)=>{

    return (
      <Tooltip title={props.TooltipTitle} placement="right">
        <ListItemButton onClick={props.Click}  sx={{fontSize:'16px'}}  divider>
        <ListItemIcon sx={{minWidth: props.StyleOpen ?'40px': '60px', color:'white'}}>
          {props.Icon}
        </ListItemIcon>
        <ListItemText primary={<span style={{fontSize:'14px', color:'white'}}><b>{props.Title}</b></span>} secondary={props.SecondText} />
      </ListItemButton>
      </Tooltip>
    )
}